import {Component, ElementRef, ViewChild} from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  standalone: true,
    imports: [],
  templateUrl: './loading-indicator.component.html',
  styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent {
    @ViewChild('loadingContainer', {static: true}) loadingContainer!: ElementRef;
}
